import { Navigate, Outlet } from "react-router-dom";

import { useAuth } from "../hooks/useAuth";
import { useGovernanceActorProfile } from "../hooks/useGovernanceActorProfile";
import { useCurrentUserRole } from "../hooks/useCurrentUserRole";
import { mayManagePaymentReconciliation } from "../lib/tenantUserAccess";

export function PaymentReconciliationRoute() {
  const { session, loading: authLoading } = useAuth();
  const actorId = session?.user?.id ?? null;
  const { role, isLoading: roleLoading, isError: roleError } = useCurrentUserRole(actorId);
  const { profile, isLoading: profileLoading, isError: profileError } = useGovernanceActorProfile(actorId);

  if (authLoading || roleLoading || profileLoading) {
    return (
      <div className="flex min-h-[40vh] items-center justify-center text-sm text-muted-foreground">Laden...</div>
    );
  }

  if (roleError || profileError || !session) {
    return <Navigate to="/login" replace />;
  }

  if (!mayManagePaymentReconciliation(role, profile)) {
    return <Navigate to="/app" replace />;
  }

  return <Outlet />;
}
